<template>
  <v-app>
    <div id="air__app__container">
      <v-snackbar bottom
                  v-model="snackbar"
                  :timeout="notification.timeout"
      >
        <header class="app__header__ernest">
          <div :class="{ error__msg: notification.level === errorMsg }">
            <v-icon v-if="notification.level === errorMsg">mdi-close</v-icon>
            <v-icon v-else>mdi-help</v-icon>
          </div>
          <div>
            <div v-if="notification.level === errorMsg"><span>Erreur</span></div>
            <div v-else><span>Information</span></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div></div>
        </header>
        <section v-html="notification.message"></section>
      </v-snackbar>
      <router-view :key="$route.path"/>
      <nav-staff v-if="user.isStaff && user.staffStatus"/>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import { ERROR_MSG } from '@/store'

export default {
  name: 'App',
  components: {
    navStaff: () => import('@/components/general/NavBars/NavStaff')
  },
  data: () => {
    return {
      errorMsg: ERROR_MSG,
      snackbar: false
    }
  },
  computed: {
    ...mapGetters(['notification']),
    ...mapGetters('User', [
      'user'
    ])
  },
  watch: {
    notification () {
      this.snackbar = true
    }
  }
}
</script>

<style lang="scss">
  @import "assets/style/font";
  @import "assets/style/colors";

  body {
    padding-top: 0;

    * {
      font-family: $paragraph;
    }

    p, h1, h2, h3, h4, h5, h6, span, li, label, button {
      color: $fontColor;
    }

    #app {
      background-color: white;
    }

    .unistra__icons {
      font-family: $symbole;
      font-size: 2em;
      cursor: pointer;
      display: flex;
      text-decoration: none;
    }

    .v-snack__content pre {
      color: white;
    }

    .v-input--selection-controls:not(.v-input--hide-details) {
      .v-input__slot {
        margin-bottom: 0;
      }

      .v-messages.theme--light {
        display: none;
      }
    }
  }

  .container {
    margin-right: auto;
    margin-left: auto;
    padding: 0 15px;

    @media all and (min-width: 1904px) {
      width: 1170px !important;
    }

    @media all and (min-width: 1264px) {
      width: 1170px !important;
    }

    .v-card__title {
      word-break: normal;
    }
  }

  .col-md-12 {
    padding-top: 0;
    padding-bottom: 0;
  }
</style>

<style lang="scss" scoped>
  @import "assets/style/colors";
  @import "assets/style/responsive";
  @import "assets/style/styleAppErnest";

  #app {
    #air__app__container {
      margin: 10px auto 0 auto;
      display: grid;
      grid-template-columns: 3fr 1fr;
      grid-gap: 30px;
      width: $large;

      @media all and (max-width: $large) and (min-width: $medium) {
        width: $medium;
      }

      @media all and (max-width: $medium) and (min-width: $small) {
        width: $small;
      }

      @media all and (max-width: $small) {
        grid-template-columns: 1fr;
        width: 100%;
      }

      #app__ernest.app__ernest__user {
        grid-column: 1/3;
      }
    }

    .v-snack::v-deep {
      .v-snack__wrapper {
        background-color: transparent;

        .v-snack__content {
          display: flex;
          flex-direction: column;
          padding: 0;

          header {
            width: 100%;
          }

          section {
            width: 100%;
            font-size: 18px;
            padding: 5px;
            color: black;
            background-color: #F5F5F5;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    .app__header__ernest {
      > div:first-child {
        &.error__msg {
          background-color: $buttonCancelColor;
        }
      }
    }
  }
</style>
